export const ROOT_HOME = "/";
export const ROOT_TIMESHEETS_MANAGEMENT = "/timesheets";
export const ROOT_JOB_MANAGEMENT = "/job-management";
export const ROOT_USER_MANAGEMENT = "/user-management";
export const ROOT_UPLOAD = "/upload";
export const ROOT_NOTIFICATIONS = "/notifications";
export const ROOT_APP_CHANGELOG = "/app-changelog";
